export default "/shSTG.153d9e3ad86bfbf2a25569ecd9baec43.png";